// Forgot password page translations
export default {
  title: "Reset Password",
  subtitle: "Please enter your email address, we will send you a reset link",
  contactServiceText: "If you forgot your account password, please",
  contactService: "Contact Customer Service",
  sendCode: "Send Verification Code",
  sendCodeAgain: "Resend",
  backToLogin: "Back to Login",
  nextStep: "Next Step",
  resetPassword: "Reset Password",
  resetSuccess: "Password reset successfully",
  resetFailed: "Password reset failed",
  codeExpired: "Verification code expired",
  countdown: "Resend in {seconds}s",
  form: {
    email: "Email Address",
    emailPlaceholder: "Please enter email (required)",
    code: "Verification Code",
    codePlaceholder: "Please enter verification code",
    newPassword: "New Password",
    newPasswordPlaceholder:
      "8-16 characters, at least 1 letter, 1 number and 1 special character (required)",
    confirmNewPassword: "Confirm New Password",
    confirmNewPasswordPlaceholder: "Confirm password (required)",
    emailRequired: "Please enter email address",
    emailFormat: "Please enter a valid email format",
    codeRequired: "Please enter verification code",
    codeFormat: "Please enter 6-digit verification code",
    newPasswordRequired: "Please enter new password",
    confirmNewPasswordRequired: "Please confirm new password",
    passwordMismatch: "The two passwords do not match",
  },
  buttons: {
    getCaptcha: "Get Verification Code",
    confirm: "Confirm",
    cancel: "Back",
  },
  steps: {
    step1: "Enter Email",
    step2: "Verify Identity",
    step3: "Set New Password",
  },
};
